```vue
<template>
  <div id="app">
    <div class="preload portada-1" />
    <div class="preload portada-2" />
    <div class="preload portada-3" />

    <Componentep
      v-if="isSmallScreen"
      :id-invitado="idInvitado"
    />

    <pantalla-g v-else />
  </div>
</template>

<script>
import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import Componentep from './components/contenedor.vue';
import PantallaG from './components/pantallas_g.vue';

export default {
  name: 'App',
  components: {
    Componentep,
    PantallaG,
  },

  setup() {
    const route = useRoute();

    const idInvitado = ref(Number(route.params.idInvitado) || undefined);
    const idFestejado = ref(Number(route.params.idFestejado) || undefined);

    const isSmallScreen = ref(window.innerWidth < 768);

    const isValidIdInvitado = computed(
      () => !isNaN(idInvitado.value) && idInvitado.value !== undefined
    );

    const isValidFestejado = computed(
      () => !isNaN(idFestejado.value) && idFestejado.value !== undefined
    );

    watch(
      () => route.params.idInvitado,
      (newId) => {
        idInvitado.value = Number(newId);
      }
    );

    watch(
      () => route.params.idFestejado,
      (newId) => {
        idFestejado.value = Number(newId);
      }
    );

    window.addEventListener('resize', () => {
      isSmallScreen.value = window.innerWidth < 768;
    });

    return {
      idInvitado,
      idFestejado,
      isSmallScreen,
      isValidIdInvitado,
      isValidFestejado,
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}

.preload {
  visibility: hidden;
  background-size: cover;
}

.preload.portada-1 {
  background-image: url('./assets/inicio.webp');
}

.preload.portada-2 {
  background-image: url('./assets/i3.png');
}

.preload.portada-3 {
  background-image: url('./assets/imagenprimera.webp');
}
</style>
```
